const MISCELLANEOUS = {
    pageDataAid: "bankMandates",
    pageTitle: {
        text: 'Banks & mandates',
        dataAid: 'header'
    },
    footerBtn: {
        text: 'Add another bank',
        dataAid: 'addBank'
    }
}

const TAB_HEADER = {
    tradingTab: {
        text: "Trading & Demat",
        dataAid: '1'
    },
    mfTab: {
        text:"Mutual fund",
        dataAid: '2'
    }
}

const BANK_CARD =  {
    bankCardDataAid: (index) => `bankAccount${index}`,
    status: {
        dataAid: 'bank',
        // text comes from API
    },
    primaryTag: {
        dataAid: 'label'
    },
    bankLogoDataAid: 'left',
    bankNameDataAid: 'title',
    bankAccountNumberDataAid: 'subtitle'
}

const BANK_AND_MANDATE = {
    ...MISCELLANEOUS,
    TAB_HEADER,
    BANK_CARD,
}

export default  BANK_AND_MANDATE;
